import { render } from "./NoticeBoard.vue?vue&type=template&id=0d38f334&ts=true"
import script from "./NoticeBoard.vue?vue&type=script&lang=ts"
export * from "./NoticeBoard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__